/** القسم 1 — «آلية دولية لتوظيف الإعلام في إدارة الفرص الاقتصادية وربط الأسواق والاستثمارات» (ملف PDF العربي). */
export const frameworkAr = {
  id: 'framework',
  previewCount: 4,
  navLabel: 'المبادرة الاعلاملية',
  eyebrow: 'الإعلام مدير الاقتصاد',
  eyebrowFeatured: true,
  title: 'آلية دولية لتوظيف الإعلام في إدارة الفرص الاقتصادية وربط الأسواق والاستثمارات',
  subtitle:
    'الإعلام، والإدارة الاقتصادية والاستثمارية، والشبكة الدولية تعمل معًا، بحيث لا تكون الحلقة التلفزيونية نهاية العملية، بل إحدى مراحلها.',
  blocks: [
    {
      icon: 'campaign',
      title: 'مقدمة: من الإعلام الناقل للاقتصاد إلى الإعلام الذي يدير حركته',
      wide: true,
      paragraphs: [
        'تنطلق المبادرة العالمية للإعلام الاقتصادي من رؤية مؤسسية أساسية: «الإعلام مدير الاقتصاد».',
        'فالإعلام الاقتصادي التقليدي يؤدي دورًا مهمًا في نقل الأخبار، وتحليل الأسواق، واستضافة المسؤولين والخبراء، وعرض المشروعات والفرص. لكن هذه الأدوار غالبًا ما تنتهي عند تقديم المحتوى ونشره، دون أن تكون هناك بالضرورة منظومة مرتبطة به تتولى تنظيم الفرص المعروضة، وربطها بالأطراف المناسبة، ومتابعة مسارات التعاون التي قد تنشأ عنها.',
        'تقدم المبادرة نموذجًا مختلفًا؛ إذ تجعل الإعلام جزءًا من منظومة إدارية واستثمارية أوسع، لا تكتفي بعرض ما يحدث في الاقتصاد، بل تعمل على تنظيم الحوار حول الفرص والتحديات، وربط أصحاب المشروعات بالمستثمرين والشركاء، وتنسيق انتقال الفرص بين الأسواق، ومتابعة مسارات التعاون الناتجة عنها.',
      ],
      closing: 'وبذلك، لا تكون الحلقة التلفزيونية نهاية العملية، بل إحدى مراحلها.',
    },
    {
      icon: 'hub',
      title: 'المبادرة جزء من منظومة نادي حلول العقاري العالمي',
      paragraphs: [
        'نادي حلول العقاري العالمي هو المنظومة الأساسية التي يجري تطويرها لربط الشركات والمطورين وملاك الأصول والمستثمرين والمؤسسات المالية ومقدمي الخدمات والأسواق المختلفة ضمن شبكة دولية متكاملة.',
        'ويرتكز النادي على تطوير نموذج جديد للتعامل مع الثروة العقارية وإدارة خدماتها وفرصها عبر الأسواق، مع توظيف الشبكات المؤسسية والمالية والتجارية والعلاقات الدولية لتسهيل الوصول إلى الفرص والشركاء المناسبين.',
        'ولا تقتصر منظومة النادي على العقارات بوصفها قطاعًا، بل يمكن أن تتقاطع أنشطته وعلاقاته وشبكاته مع قطاعات اقتصادية متعددة، بحسب طبيعة الفرص والشراكات التي يعمل عليها.',
        'وفي هذا الإطار، تأتي المبادرة العالمية للإعلام الاقتصادي باعتبارها أحد المحركات العملية لمنظومة النادي؛ فهي تربط ما يجري داخل الشبكة من فرص ومشروعات واحتياجات وحلول بمنظومة إعلامية دولية، وتحوّل جزءًا من هذا النشاط إلى محتوى منظم يتيح الحوار والتواصل والربط بين الأطراف.',
      ],
      closing:
        'وبالتالي فالمبادرة ليست مشروعًا إعلاميًا مستقلًا عن نادي حلول، بل جزء من نموذجه الأوسع في إدارة الفرص الاقتصادية وربط الأسواق.',
    },
    {
      icon: 'lightbulb',
      title: 'ما المبادرة العالمية للإعلام الاقتصادي؟',
      paragraphs: [
        'هي مبادرة لتطوير شبكة دولية من البرامج الاقتصادية المترابطة، تعمل في أسواق متعددة، وتستخدم التلفزيون والإعلام الرقمي والصحافة والفعاليات وشبكات الأعمال وغيرها من الوسائل لتقديم الفرص الاقتصادية وإدارة الحوار حولها، وربطها بالأطراف والأسواق المناسبة.',
        'ولا يقوم النموذج على برامج منفصلة تقتصر على عرض الأخبار واستضافة الضيوف، بل على برامج اقتصادية ذات آلية تشغيلية محددة، تجمع بين:',
      ],
      bullets: [
        'عرض الفرص والمشروعات والاحتياجات الاقتصادية.',
        'مناقشة الفرص بصورة عملية بمشاركة الأطراف ذات الصلة.',
        'إشراك المستثمرين والشركات والخبراء ومقدمي الحلول.',
        'ربط الفرص بالأسواق والشركاء المحتملين داخل الشبكة الدولية.',
        'تنسيق المتابعة الاقتصادية والتجارية لما ينتج عن هذه اللقاءات.',
      ],
      closing:
        'ويعتمد النموذج على التكامل بين المحتوى الإعلامي، وإدارة الفرص، وشبكة العلاقات الاقتصادية والاستثمارية.',
    },
    {
      icon: 'live_tv',
      title: 'كيف يعمل البرنامج عمليًا؟',
      wide: true,
      paragraphs: [
        'تم تصميم البرنامج ليكون مساحة عمل اقتصادية منظّمة، وليس مجرد مساحة حوار تلفزيوني. ويتكون نموذجه من فقرات مترابطة، تتكامل فيها المعرفة الاقتصادية مع عرض الفرص ومناقشتها وتنسيق التعامل بشأنها.',
      ],
      labeled: [
        {
          label: 'أولًا: نافذة الاقتصاد والفرص',
          text: 'تخصص فقرة لعرض الأولويات الاقتصادية والفرص والمشروعات والتحديات في الدولة، بمشاركة مسؤولين حكوميين وممثلين عن المؤسسات والقطاعات والشركات، بحسب موضوع الحلقة. وقد تتناول الفقرة مشروعًا يحتاج إلى استثمار، أو قطاعًا يبحث عن شركاء، أو منطقة تحتاج إلى تطوير، أو شركة ترغب في التوسع، أو تحديًا اقتصاديًا يتطلب حلولًا فنية أو مالية أو تشغيلية. والهدف هو تعريف المشاهدين والمشاركين بالاحتياجات الفعلية، وليس الاكتفاء بعرض معلومات عامة عن القطاع.',
        },
        {
          label: 'ثانيًا: مجلس الأعمال',
          text: 'يجمع البرنامج رجال الأعمال والمستثمرين وممثلي الشركات والخبراء والمتخصصين لمناقشة فرص محددة، وتحديد الاحتياجات والتحديات، واستعراض الحلول الممكنة، وبحث أشكال التعاون والشراكات. ويُدار الحوار وفق موضوع واضح وهدف عملي، بحيث يساهم المشاركون في تحديد الإمكانات المتاحة، ونوعية الشركاء المطلوبين، والخطوات التي يمكن اتخاذها لمواصلة العمل بعد الحلقة. ويمكن أن تتم المشاركة بالحضور داخل الاستوديو أو عن بُعد، بما يتيح إشراك أطراف من دول وأسواق مختلفة.',
        },
        {
          label: 'ثالثًا: غرفة الفرص',
          text: 'غرفة الفرص هي المحور العملي الأساسي في البرنامج. تُخصص في كل حلقة مساحة لفرصة اقتصادية محددة تم اختيارها وتجهيز معلوماتها مسبقًا، ويشارك فيها صاحب الفرصة والأطراف ذات الصلة، إلى جانب المستثمرين أو الشركات أو الخبراء الذين يمكن أن يسهموا في تطويرها. وقد تكون الفرصة مشروعًا عقاريًا يبحث عن مستثمر، أو منطقة تحتاج إلى شركات لتطوير البنية الأساسية، أو منشأة تحتاج إلى شريك تقني، أو شركة تبحث عن تمويل أو دخول سوق جديدة. وتُناقش الفرصة وفق مجموعة من الأسئلة العملية: ما الاحتياج الفعلي؟ ما الحل أو الشراكة المطلوبة؟ من الأطراف التي يمكن أن تقدمها؟ ما المعلومات الإضافية اللازمة؟ وما الخطوة التالية التي ينبغي اتخاذها؟ وعند الحاجة، يمكن أن تستمر مناقشة التفاصيل المالية أو التجارية أو السرية خارج البث العام، ضمن اجتماعات مباشرة أو افتراضية مخصصة للأطراف المعنية.',
        },
        {
          label: 'رابعًا: متابعة الفرص والنتائج',
          text: 'لا يُفترض أن ينتهي التعامل مع الفرصة بمجرد عرضها في الحلقة. فعندما تنشأ عنها استفسارات جادة أو اجتماعات أو خطوات تفاوضية، يتولى نادي حلول تنسيق المتابعة وفق طبيعة كل حالة. كما يمكن للبرنامج، في حلقات لاحقة، متابعة بعض الفرص التي سبق عرضها، وتسليط الضوء على ما تحقق فيها، والعقبات التي واجهتها، والدروس المستفادة منها.',
        },
      ],
      closing:
        'وبذلك يصبح البرنامج مساحة متجددة لمناقشة الفرص ومتابعة تطورها، وليس مجموعة حلقات منفصلة لا رابط عمليًا بينها.',
    },
    {
      icon: 'moving',
      title: 'ماذا يحدث بعد عرض الفرصة؟',
      wide: true,
      paragraphs: [
        'هنا يظهر الدور الذي يميز نموذج المبادرة عن العرض الإعلامي التقليدي. تعمل المبادرة من خلال وظيفة إدارية واستثمارية ينظمها نادي حلول، وتتكامل مع البرنامج والشركاء المشاركين. وتشمل دورة العمل المقترحة:',
      ],
      numbered: [
        {
          label: 'استقبال الفرصة',
          text: 'من جهة حكومية أو شركة أو مطور أو مالك أصل أو مؤسسة تبحث عن شريك أو تمويل أو حل.',
        },
        {
          label: 'التقييم الأولي',
          text: 'جمع المعلومات المتاحة، وفهم طبيعة الاحتياج، وتحديد مدى جاهزية الفرصة وما يلزم لاستكمال دراستها.',
        },
        {
          label: 'تحديد الأطراف والأسواق المناسبة',
          text: 'تحديد نوع المستثمر أو المطور أو الممول أو الشريك الفني أو التجاري المطلوب، والأسواق التي يمكن أن تتوافر فيها الأطراف المناسبة.',
        },
        {
          label: 'الإعداد الإعلامي والتشغيلي',
          text: 'تجهيز الفرصة للنقاش في البرنامج، وتحديد الأطراف المطلوب مشاركتها، والأسئلة التي ينبغي تناولها، والنتيجة العملية المستهدفة من الجلسة.',
        },
        {
          label: 'إدارة اللقاء والاهتمام الناتج عنه',
          text: 'تقديم الفرصة ومناقشتها، ثم رصد الأطراف المهتمة وتقييم مدى ملاءمتها لها.',
        },
        {
          label: 'تنسيق المتابعة',
          text: 'تنظيم التواصل والاجتماعات وتبادل المعلومات واستكمال الفحص والتفاوض بالتنسيق مع الأطراف المعنية.',
        },
      ],
      closing: [
        'وهنا يؤدي كل طرف دوره: الشريك الإعلامي يتولى إنتاج المحتوى وتقديمه ونشره، بينما يتولى نادي حلول إدارة إطار الفرص والربط بين الأسواق والأطراف، ويتخذ أصحاب المشروعات والمستثمرون قراراتهم وفق دراساتهم وإجراءاتهم.',
        'ولا تعني هذه الآلية ضمان تمويل الفرص أو إتمام الصفقات، وإنما توفر مسارًا منظمًا لتحويل العرض الإعلامي والاهتمام الناتج عنه إلى تواصل وتقييم وتعاون اقتصادي قابل للمتابعة.',
      ],
    },
    {
      icon: 'public',
      title: 'كيف تُستخدم الشبكة الدولية في إدارة الفرص؟',
      paragraphs: [
        'تقوم المبادرة على إنشاء برامج اقتصادية في مجموعة من الدول، ترتبط جميعها بشبكة واحدة ضمن إطار استراتيجي مشترك.',
        'فقد تُعرض فرصة في البرنامج المصري، بينما يكون المستثمر المناسب أو الشريك الفني في السعودية أو بريطانيا أو تركيا أو سنغافورة أو غيرها من الأسواق المشاركة.',
        'ومن خلال الشبكة، يمكن تحديد الأسواق والأطراف الأقرب إلى احتياجات الفرصة، وتقديمها عبر القنوات المناسبة، ثم تنسيق التواصل مع الأطراف المهتمة. وفي المقابل، يمكن للشبكة أن تنقل فرصًا وشركات وخبرات من الأسواق الأخرى إلى الدولة التي تحتاج إليها.',
        'ولا يعني ذلك أن كل فرصة ستُعرض في جميع الدول؛ إذ يتحدد نطاق عرضها والأسواق المستهدفة وفق طبيعتها، واحتياجاتها، والجهات المناسبة لها.',
      ],
      closing:
        'وبهذا تصبح البرامج الاقتصادية المحلية بوابات مترابطة للأسواق التي تعمل فيها، ضمن منظومة دولية تتيح تبادل الفرص والعلاقات الاقتصادية عبر الحدود.',
    },
    {
      icon: 'diversity_3',
      title: 'منظومة الشركاء والأدوات المساندة',
      paragraphs: [
        'لا تعتمد إدارة الفرص على الإعلام وحده، بل تتكامل مع شبكات نادي حلول وعلاقاته وشركائه، بما في ذلك:',
      ],
      bullets: [
        'البنوك والمؤسسات المالية وشركات الاستثمار.',
        'مؤسسات إدارة الثروات والمكاتب العائلية والمستثمرون.',
        'الأندية المهنية والنخبوية وشبكات الأعمال.',
        'الشركات والمطورون ومقدمو الخدمات المتخصصة.',
        'الجهات الحكومية والمؤسسات الاقتصادية.',
        'الشركاء الإعلاميون والإنتاجيون في الأسواق المختلفة.',
      ],
      closing: [
        'وتؤدي هذه الأطراف أدوارًا مختلفة بحسب الفرصة: تقديمها، أو دراستها، أو توفير التمويل، أو تقديم الخبرة الفنية، أو الوصول إلى السوق، أو تشغيل المشروع، أو تطوير شراكة بشأنه.',
        'أما الوسائل الإعلامية فتشمل التلفزيون والمحتوى الرقمي والصحافة ومنصات التواصل والفعاليات واللقاءات الاقتصادية. ويُختار المزيج المناسب منها وفق طبيعة الفرصة والجمهور والسوق المستهدف.',
      ],
    },
    {
      icon: 'account_tree',
      title: 'إدارة المبادرة وأدوار الأطراف',
      wide: true,
      labeled: [
        {
          label: 'نادي حلول العقاري العالمي',
          text: 'يتولى تطوير المبادرة وإدارة إطارها الاستراتيجي والتشغيلي، وتنظيم دورة الفرص، وربط الأسواق والأطراف، وتنسيق المتابعة الاقتصادية والاستثمارية، بالتعاون مع الشركاء المعنيين.',
        },
        {
          label: 'الشركاء الإعلاميون والإنتاجيون',
          text: 'يتولون تطوير المحتوى والبرامج وتنفيذها ونشرها في أسواقهم وفق الإطار المتفق عليه.',
        },
        {
          label: 'الجهات الحكومية والمؤسسات والشركات',
          text: 'تقدم المعلومات والفرص والاحتياجات ذات الصلة، وتشارك في الحوار والتنسيق وفق اختصاص كل جهة.',
        },
        {
          label: 'المستثمرون والشركات ومقدمو الحلول',
          text: 'يدرسون الفرص التي تناسب إمكاناتهم، ويشاركون في المناقشات والاجتماعات، ويقررون الدخول في الفحص أو التفاوض أو التعاون وفق إجراءاتهم الخاصة.',
        },
      ],
      closing:
        'ويضمن هذا التقسيم وضوح المسؤوليات، والفصل بين الدور الإعلامي ودور إدارة الفرص، والتكامل بينهما ضمن نموذج واحد.',
    },
    {
      icon: 'travel_explore',
      title: 'الهيكل الدولي وخطة التوسع',
      paragraphs: [
        'تستهدف المبادرة في مرحلتها الأولى مجموعة من 15 سوقًا رئيسيًا، مع خطة للتوسع التدريجي نحو شبكة تضم 100 دولة خلال خمس سنوات.',
      ],
      stats: [
        { value: '15', label: 'سوقًا رئيسيًا في المرحلة الأولى' },
        { value: '100', label: 'دولة ضمن الشبكة' },
        { value: '5', label: 'سنوات للتوسع الكامل' },
      ],
      closing: [
        'ويتم التوسع من خلال اختيار الشركاء الإعلاميين والإنتاجيين المناسبين، وتطوير البرامج الاقتصادية المحلية، وربطها بآلية إدارة الفرص والشبكة الدولية.',
        'وكل سوق جديد يضيف إلى المنظومة شركات ومؤسسات ومستثمرين وخبرات واحتياجات اقتصادية، ويوسع إمكانية الربط بين الفرص والأطراف المناسبة عبر الأسواق.',
      ],
    },
    {
      icon: 'flag',
      title: 'الخلاصة',
      wide: true,
      highlight: true,
      paragraphs: [
        'المبادرة العالمية للإعلام الاقتصادي هي أداة تشغيلية ضمن منظومة نادي حلول العقاري العالمي، تهدف إلى توظيف الإعلام في إدارة الحركة الاقتصادية وربط الفرص والأسواق والشركاء عبر شبكة دولية متعددة الدول.',
        'ويتمثل اختلافها الأساسي في الجمع بين ثلاثة عناصر تعمل بصورة متكاملة:',
      ],
      flow: [
        'الإعلام الذي يعرض الفرص وينظم الحوار حولها',
        'الإدارة الاقتصادية والاستثمارية التي تتولى تنسيق مسارها',
        'الشبكة الدولية التي تربط أصحاب الفرص بالمستثمرين والشركات والمؤسسات والأسواق المناسبة',
      ],
      flowJoin: '+',
      closing: [
        'وبذلك لا يكون البرنامج مجرد مساحة لعرض الأخبار والمشروعات، وإنما مساحة عمل اقتصادي منظمة تبدأ بعرض الفرصة ومناقشتها، وتمتد إلى تنسيق التواصل بشأنها ومتابعة مسارها، وفق طبيعة كل حالة وإمكانات الأطراف المعنية.',
        'وهذا هو جوهر رؤية نادي حلول العقاري العالمي: استخدام الإعلام، إلى جانب الشبكات المالية والمؤسسية والتجارية، كأداة عملية لإدارة الفرص وربط الأسواق وتحفيز التعاون الاقتصادي عبر الحدود.',
      ],
    },
  ],
};
